/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */
import { useQuery } from 'react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { BEResponseListFileDocumentoExt } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

/**
 * Restituisce la lista dei documenti da firmare associati ad un idTaskInstance
 * @summary Lista documenti
 */
export const getBackAttivitaIdDocumentiElenco = (
  idTaskInstance: string,
  options?: SecondParameter<typeof apiClientRequest>,
  signal?: AbortSignal,
) => {
  return apiClientRequest<BEResponseListFileDocumentoExt>(
    {
      url: `/framework-bo-procedimenti/attivita/${idTaskInstance}/documenti/elenco`,
      method: 'get',
      signal,
    },
    options,
  );
};

export const getGetBackAttivitaIdDocumentiElencoQueryKey = (
  idTaskInstance: string,
) =>
  [
    `/framework-bo-procedimenti/attivita/${idTaskInstance}/documenti/elenco`,
  ] as const;

export const getGetBackAttivitaIdDocumentiElencoQueryOptions = <
  TData = Awaited<ReturnType<typeof getBackAttivitaIdDocumentiElenco>>,
  TError = ErrorType<unknown>,
>(
  idTaskInstance: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAttivitaIdDocumentiElenco>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryOptions<
  Awaited<ReturnType<typeof getBackAttivitaIdDocumentiElenco>>,
  TError,
  TData
> & { queryKey: QueryKey } => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetBackAttivitaIdDocumentiElencoQueryKey(idTaskInstance);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getBackAttivitaIdDocumentiElenco>>
  > = ({ signal }) =>
    getBackAttivitaIdDocumentiElenco(idTaskInstance, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!idTaskInstance, ...queryOptions };
};

export type GetBackAttivitaIdDocumentiElencoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBackAttivitaIdDocumentiElenco>>
>;
export type GetBackAttivitaIdDocumentiElencoQueryError = ErrorType<unknown>;

/**
 * @summary Lista documenti
 */
export const useGetBackAttivitaIdDocumentiElenco = <
  TData = Awaited<ReturnType<typeof getBackAttivitaIdDocumentiElenco>>,
  TError = ErrorType<unknown>,
>(
  idTaskInstance: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getBackAttivitaIdDocumentiElenco>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetBackAttivitaIdDocumentiElencoQueryOptions(
    idTaskInstance,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
